// Aufteilung der Upload-Dateien in Bundle (ein Multipart-POST) und
// Warteschlange großer Dateien (je ein Stream-PUT an /upload-file, seit
// 2026-10-02; vorher 80-MB-Chunks an Seafile) — reine Funktion (Audit
// 2026-09-24, M14).
//
// Regel 1 (seit den 1,8-GB-Video-Tests): jede Datei über `singleLimit`
// (50 MB) geht einzeln. Regel 2: solange die Bundle-SUMME über
// `bundleLimit` (90 MB) liegt, wandert die jeweils größte Bundle-Datei in die
// Warteschlange. Vorher prüfte niemand die Summe: Voice-WAV + Premix +
// 45-MB-Video ergaben zusammen über 100 MB, Caddy (`request_body max_size
// 100MB` auf /api/upload) antwortete 413 — bei jedem Versuch identisch.
//
// Die letzte Bundle-Datei trägt `isFinal` (Vertrag mit dem Dienst); in die
// Warteschlange gewanderte Dateien verlieren die Markierung.

export interface SplittableFile {
  filename: string;
  blob: Blob;
  isFinal?: boolean;
}

export const BUNDLE_SUM_LIMIT = 90 * 1024 * 1024;

export function splitBundle<T extends SplittableFile>(
  planned: T[],
  limits: { singleLimit: number; bundleLimit: number },
): { bundle: T[]; large: { filename: string; blob: Blob }[] } {
  const bundle: T[] = [];
  const large: { filename: string; blob: Blob }[] = [];
  for (const f of planned) {
    if (f.blob.size > limits.singleLimit) large.push({ filename: f.filename, blob: f.blob });
    else bundle.push(f);
  }
  let sum = bundle.reduce((s, f) => s + f.blob.size, 0);
  while (sum > limits.bundleLimit && bundle.length > 1) {
    let biggest = 0;
    for (let i = 1; i < bundle.length; i++) if (bundle[i]!.blob.size > bundle[biggest]!.blob.size) biggest = i;
    const [moved] = bundle.splice(biggest, 1);
    large.push({ filename: moved!.filename, blob: moved!.blob });
    sum -= moved!.blob.size;
  }
  if (bundle.length > 0) {
    for (const f of bundle) f.isFinal = false;
    bundle[bundle.length - 1]!.isFinal = true;
  }
  return { bundle, large };
}
